/**
 * Created by Andrey Popov on 12/28/22.
 */

const CardsCounter = function () {
    this.onRefresh = function () {};

    this.update();
};

CardsCounter.prototype.update = function () {
    this.countOfCards = Game.currentGame.table.getAmountOfCards();

    this.isValid = (this.countOfCards % 3) === 0;

    if (!this.isValid) {
        this.lowValidValue = Math.floor(this.countOfCards / 3) * 3;
        this.upValidValue = Math.ceil(this.countOfCards / 3) * 3;
    }

    this.onRefresh();
};